import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import MisHeader from '../../Components/MisHeader'

class CheckBattle extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentQuestion: null,
      page: 0,
    }
  }
  componentDidMount() {
    const { results } = this.props
    let questions = Object.keys(results)
    this.setState({ currentQuestion: results[questions[0]] })
  }

  removeScreen() {
    const {
      removeScreen,
      removeInfo,
      removeQuestion,
      getBattle,
      removeResume,
      setIndividualBattle,
    } = this.props
    removeScreen('check_battle_screen')
    removeInfo({
      hits: 0,
      fails: 0,
      question: 1,
    })
    removeQuestion(null)
    removeResume(null)
    setIndividualBattle(null)
    getBattle(true)
  }
  renderAnswers(answer) {
    const { currentQuestion } = this.state

    const className = [
      'mis--battle__questions--item',
      currentQuestion.correctChoice == answer.key ? 'review--success' : null,
      !currentQuestion.right && currentQuestion.selectedKey == answer.key ? 'review--failed' : null,
    ]
      .join(' ')
      .trim()
    answer.text = answer.text || answer.title
    return (
      <div className={className} key={answer.key}>
        <label htmlFor={answer.id}>
          <FormattedMessage id={answer.text} />
        </label>
        <input
          id={answer.key}
          key={answer.key}
          name="answer"
          value={answer.key}
          type="radio"
        ></input>
      </div>
    )
  }

  renderPaginator() {
    const { page } = this.state
    const { results, addHowlSound } = this.props
    let questions = Object.keys(results)

    return (
      <div className="mina--paginator">
        <div className="mina--paginator__pages">
          {page > 0 ? (
            <span
              className="icon-arrow-left"
              onClick={() => {
                page > 0
                  ? this.setState({ page: page - 1, currentQuestion: results[questions[page - 1]] })
                  : null
                addHowlSound('button_click_icon')
              }}
            />
          ) : null}
          {questions.map((p, i) => (
            <span
              onClick={() => {
                this.setState({ page: i, currentQuestion: results[p] })
                addHowlSound('button_click_icon')
              }}
              key={p}
              className={page == p ? 'bullet active' : 'bullet'}
            ></span>
          ))}
          {page < questions.length - 1 ? (
            <span
              className="icon-arrow-right"
              onClick={() => {
                page < questions.length - 1
                  ? this.setState({ page: page + 1, currentQuestion: results[questions[page + 1]] })
                  : null
                addHowlSound('button_click_icon')
              }}
            />
          ) : null}
        </div>
      </div>
    )
  }
  render() {
    const { currentQuestion, page } = this.state
    const { addHowlSound, hideTabs } = this.props
    const { helpBtn, settingsBtn } = hideTabs || {}

    let info = this.props.info || {}

    if (!currentQuestion) {
      return (
        <div>
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }

    const answers = currentQuestion.choices

    return (
      <div className="container background background--mina">
        <div className="content">
          <div className="mis">
            <MisHeader helpBtn={helpBtn} settingsBtn={settingsBtn} />
            <div className="mis--body">
              <div className="mis--battle">
                <div className="mis--battle__head">
                  <div className="mis--battle__title visibility--hidden">
                    <span>
                      <FormattedMessage id="battles.challenge" />
                    </span>
                  </div>
                  <div className="mis--battle__counter">
                    <div className="mis--battle__counter--item">
                      <span className="green">{info.hits}</span>
                    </div>
                    <div className="mis--battle__counter--item">
                      <span className="red">{info.fails}</span>
                    </div>
                  </div>
                </div>
                <div className="mis--num__question">{page + 1 || 1}/5</div>
                <div className="mis--battle__block">
                  <div className="mis--battle__questions review--questions">
                    <div className="mis--battle__questions--title">
                      <FormattedMessage id={currentQuestion.question} />
                    </div>
                    {answers.map((a) => this.renderAnswers(a))}
                    {this.renderPaginator()}
                  </div>

                  <div
                    onClick={() => {
                      {
                        this.removeScreen()
                        addHowlSound('button_click')
                      }
                    }}
                    className="btn--shape shape--orange"
                  >
                    <div className="btn--shape__canvas">
                      <FormattedMessage id={'battles.continue'} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CheckBattle.propTypes = {
  results: PropTypes.object,
  removeScreen: PropTypes.func,
  setIndividualBattle: PropTypes.func,
  info: PropTypes.object,
  removeInfo: PropTypes.func,
  removeQuestion: PropTypes.func,
  getBattle: PropTypes.func,
  removeResume: PropTypes.func,
  addHowlSound: PropTypes.func,
  hideTabs: PropTypes.object,
}

export default CheckBattle
